<template>
  <div class="user-profile">
    <h2>User Profile</h2>
    <div v-if="user">
      <p><strong>ID:</strong> {{ user.id }}</p>
      <p><strong>Username:</strong> {{ user.username }}</p>
      <p><strong>Email:</strong> {{ user.email }}</p>
      <p><strong>First Name:</strong> {{ user.firstName }}</p>
      <p><strong>Last Name:</strong> {{ user.lastName }}</p>
      <p><strong>First Name Translation:</strong> {{ user.firstNameTranslate }}</p>
      <p><strong>Last Name Translation:</strong> {{ user.lastNameTranslate }}</p>
      <p><strong>Birth Date:</strong> {{ user.birthDate }}</p>
      <p><strong>Gender:</strong> {{ user.gender }}</p>
      <p><strong>Phone:</strong> {{ user.phone }}</p>
      <p><strong>Secondary Phone:</strong> {{ user.phone2 }}</p>
      <p><strong>Country:</strong> {{ user.country }}</p>
      <p><strong>City:</strong> {{ user.city }}</p>
      <p><strong>Language:</strong> {{ user.lang }}</p>
      <p><strong>Image:</strong> <img :src="user.image" alt="User Image" /></p>
      <p><strong>Blocked:</strong> {{ user.blocked }}</p>
      <p><strong>Can Comment:</strong> {{ user.canComment }}</p>
      <p><strong>Is Private:</strong> {{ user.isPrivate }}</p>
      <p><strong>Can Create Ride:</strong> {{ user.canCreateRide }}</p>
      <p><strong>IP Address:</strong> {{ user.ipAddr }}</p>
    </div>
    <div v-else>
      <p>Loading...</p>
    </div>
  </div>
</template>

<script>
import usersService from '@/services/usersService';

export default {
  name: "UserProfile",
  data() {
    return {
      user: null,
    };
  },
  async created() {
    try {
      this.user = await usersService.getCurrentUser();
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  },
};
</script>

<style scoped>
.user-profile {
  padding: 20px;
}
</style>